import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2df9c9e4")

_pushScopeId("data-v-2df9c9e4")
const _hoisted_1 = {
  key: 0,
  class: "vue-content-center"
}
const _hoisted_2 = /*#__PURE__*/_createTextVNode("読み込み中...")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("アカウントをこの施設から削除してもいいですか？ ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_list_title = _resolveComponent("list-title")
  const _component_list_row = _resolveComponent("list-row")
  const _component_loading_message = _resolveComponent("loading-message")
  const _component_vue_y_scroll_area = _resolveComponent("vue-y-scroll-area")
  const _component_confirm = _resolveComponent("confirm")
  const _component_vue_content = _resolveComponent("vue-content")

  return (_openBlock(), _createBlock(_component_vue_content, { class: "vue-content-remain-tab-child" }, {
    default: _withId(() => [
      _createVNode(_component_list_title, { titles: _ctx.accountTitles }, null, 8, ["titles"]),
      _createVNode(_component_vue_y_scroll_area, null, {
        default: _withId(() => [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.accountList, (account, index) => {
            return (_openBlock(), _createBlock(_component_list_row, {
              key: account.id,
              rowId: account.id,
              columns: _ctx.accountRows[index],
              onClick: _ctx.onClick
            }, null, 8, ["rowId", "columns", "onClick"]))
          }), 128)),
          (_ctx.requestStatus === _ctx.RequestStatus.Requesting)
            ? (_openBlock(), _createBlock("div", _hoisted_1, [
                _createVNode(_component_loading_message, null, {
                  default: _withId(() => [
                    _hoisted_2
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_component_confirm, {
        ref: "confirmRef",
        onYes: _ctx.yes
      }, {
        default: _withId(() => [
          _hoisted_3
        ]),
        _: 1
      }, 8, ["onYes"])
    ]),
    _: 1
  }))
})